export enum AppRoute {
  Documents,
  DocumentsHome,
  UserManagement,
  ChangePassword,
  AddUser,
  EditUser,
  PendingApproval,
  Recents,
  Favourites,
  DashboardsWorkbooks,
  Dashboards,
  DashboardsSearch,
  Uploads,
}
